module.exports = __webpack_public_path__ + "static/img/weather42.a0da9f75.png";